import { useEffect, useState } from 'react';

// Whether the Help & tours panel is open, and the rect of the button that
// opened it (the panel drops down from it). The Help button lives in each
// Forms page header; the panel itself renders from FormsHelp.

const CLOSED = { open: false, anchor: null };

let panel = CLOSED;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(panel));

const rectOf = (rect) =>
  rect
    ? {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
      }
    : null;

export const getHelpPanel = () => panel;

export const openHelpPanel = (anchorRect = null) => {
  panel = { open: true, anchor: rectOf(anchorRect) };
  emit();
};

export const closeHelpPanel = () => {
  if (!panel.open) return;
  panel = CLOSED;
  emit();
};

export const useHelpPanel = () => {
  const [current, setCurrent] = useState(getHelpPanel);
  useEffect(() => {
    listeners.add(setCurrent);
    setCurrent(getHelpPanel());
    return () => {
      listeners.delete(setCurrent);
    };
  }, []);
  return current;
};

// Tests only.
export const resetHelpPanelForTests = () => {
  panel = CLOSED;
  listeners.clear();
};
